export default {
  MAX_U27: 27,
  MIN_FRIENDS: 18
}
